$.getJSON('https://ipapi.co/json/', function(data){
  
  var contactUsLocal =  document.getElementById('contact-us-local');
  var contactUsGlobal =  document.getElementById('contact-us-global');
  
  if (data.country === 'CY') {
    console.log("Visitors from cyprus");
    //var element = document.getElementById('main--title');
    //var mainBnrElem =  "<br>Extra 20% off and free delivery<br>\n    <span class=\"disc--condition\">*for purchases above 20€</span>\n    <span class=\"disc--condition--code\">Use code: \"SPECIAL20\" at checkout</span>";
    
    //element.insertAdjacentHTML('beforeend', mainBnrElem);
    var shippingTxtLocal =  document.getElementById('shipping-product-page');
    
    var notificationTxt =  document.getElementById('special');
    notificationTxt.innerText = "FREE SHIPPING ON ORDERS OVER €20";
    shippingTxtLocal.innerText = "Free delivery on all orders above €20. Order under this amount a shipping cost of €5 will be charged.";
    
    
    
  	var additionalInfoTxt =  document.getElementById('special-info');
    if (additionalInfoTxt)  {
      additionalInfoTxt.innerText = "Free shipping over €20";
    }
    
    if (contactUsGlobal)  {
      contactUsGlobal.style.display = "none";
      console.log(contactUsGlobal)
    }
    
     
  } else {
    var shippingTxtLocal =  document.getElementById('shipping-product-page');
    var notificationTxt =  document.getElementById('special');
    notificationTxt.innerText = "FREE SHIPPING WORLDWIDE ON ORDERS OVER €70";
    shippingTxtLocal.innerText = "Free delivery on all orders above €70. Order under this amount a shipping cost of €9.90 will be charged.";
    
    var additionalInfoTxt =  document.getElementById('special-info');
    if (additionalInfoTxt)  {
      additionalInfoTxt.innerText = "Free shipping over €70";
    }
    if (contactUsLocal)  {
    contactUsLocal.style.display = "none";
    }
    
    console.log(contactUsLocal)
  }
  
  
  
})  


/*
$(function(){
  
  let domElem = ``;
  const productImagesContainer = document.getElementById('product-images');
  const variantInfo = document.querySelectorAll('.variant-info');
  const variantInfoArr = Array.prototype.slice.call(variantInfo);

  alert(window.location.href.split('?variant=')[1])
  const varaintFromUrl =window.location.href.split('?variant=')[1];

  let productImages;

  variantInfoArr.forEach((item) => {
    if (item.innerText.split('-')[0] === varaintFromUrl) {
      let variantSelected = item.innerText.split('-')[1];
      productImages = document.querySelectorAll(
        `[data-thumbnail-color="${variantSelected}"]`
      );
    }
  });

  productImagesContainer.innerHTML = '';

  const productImagesArr = Array.prototype.slice.call(productImages);

  productImagesArr.forEach((item) => {
    return (domElem += `<div class="product-image"> ${item.outerHTML} </div>`);
  });

})


function ready() {
    let domElem = ``;
  const productImagesContainer = document.getElementById('product-images');
  const variantInfo = document.querySelectorAll('.variant-info');
  const variantInfoArr = Array.prototype.slice.call(variantInfo);

  const varaintFromUrl =window.location.href.split('?variant=')[1];

  let productImages;

  variantInfoArr.forEach((item) => {
    if (item.innerText.split('-')[0] === varaintFromUrl) {
      let variantSelected = item.innerText.split('-')[1];
      productImages = document.querySelectorAll(
        `[data-thumbnail-color="${variantSelected}"]`
      );
    }
  });

  productImagesContainer.innerHTML = '';

  const productImagesArr = Array.prototype.slice.call(productImages);

  productImagesArr.forEach((item) => {
    return (domElem += `<div class="product-image"> ${item.outerHTML} </div>`);
  });
  }

  document.addEventListener("DOMContentLoaded", ready);
  
  */


function hideImage(){
  
  const productVariantImgs = document.querySelectorAll('.prod-variant-image');
  const productVariantImgsArr = Array.prototype.slice.call(productVariantImgs);

  productVariantImgs.forEach(item=> {
   
      item.classList.add("image--disabled")
     
  })
  
}

hideImage()


function updateVariantImgs() {
  
  const tempImage = document.querySelector('.temporary-image-container');
  const variantInfo = document.querySelectorAll('.variant-info');
  const variantInfoArr = Array.prototype.slice.call(variantInfo);

  const varaintFromUrl = window.location.href.split('?variant=')[1];

  let productImages;

  variantInfoArr.forEach((item) => {
    if (item.innerText.split('-')[0] === varaintFromUrl) {
      console.log(item);
      let variantSelected = item.innerText.split('-')[1];
      productImages = document.querySelectorAll(
        `[data-thumbnail-color="${variantSelected}"]`
      );
    }
  });


  const productImagesArr = Array.prototype.slice.call(productImages);

  productImagesArr.forEach((item) => {
    item.classList.remove("image--disabled")
  });

  tempImage.classList.add("image--disabled")
}


setTimeout(() => {updateVariantImgs()}, 2700);

